export default __webpack_public_path__ + "058c6976ce846aa3c29a802b825f835e.svg";